import MotorVehiclePropertyValueAndTaxInfo from 'src/components/PropertyValueAndTaxInfo/MotorVehiclePropertyValueAndTaxInfo';
import NonMotorVehiclePropertyValueAndTaxInfo from 'src/components/PropertyValueAndTaxInfo/NonMotorVehiclePropertyValueAndTaxInfo';
import Section from 'src/components/util/Section';

export default function PropertyValueAndTaxInfo({ type = '' }) {
  return (
    <Section title="Property Value and Tax Information">
      <p>
        This section may not apply to all applicants. If you know the information requested, include
        it. If you do not know it please proceed to the next section.
      </p>
      {type === 'vehicle' ? (
        <MotorVehiclePropertyValueAndTaxInfo />
      ) : (
        <NonMotorVehiclePropertyValueAndTaxInfo />
      )}
    </Section>
  );
}
